export default "__VITE_ASSET__4OLM3sS5__"